import { render, staticRenderFns } from "./PaymentList.vue?vue&type=template&id=24040c20"
import script from "./PaymentList.vue?vue&type=script&lang=js"
export * from "./PaymentList.vue?vue&type=script&lang=js"
import style0 from "./PaymentList.vue?vue&type=style&index=0&id=24040c20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports